/**
 * cadGeom — frame conversion between the canvas (rotated page, 1000 x unitH
 * units) and the CAD geometry index (unrotated page, 1000 x unitH0 units).
 */
import { rotatePoints } from "./pageState";

/** unitH of the unrotated page given the rotated one. */
export const unrotatedUnitH = (unitH, rotation) => ((rotation % 180) === 90 ? 1e6 / unitH : unitH);

/** Canvas point(s) -> CAD frame. */
export function toCadFrame(pts, rotation, unitH) {
  let cur = pts, h = unitH;
  const steps = ((rotation % 360) + 360) % 360 / 90;
  for (let i = 0; i < steps; i++) { const h2 = 1e6 / h; cur = rotatePoints(cur, h, h2, -1); h = h2; }
  return cur;
}

/** CAD frame point(s) -> canvas frame. */
export function fromCadFrame(pts, rotation, unitH) {
  let h = unrotatedUnitH(unitH, rotation), cur = pts;
  const steps = ((rotation % 360) + 360) % 360 / 90;
  for (let i = 0; i < steps; i++) { const h2 = 1e6 / h; cur = rotatePoints(cur, h, h2, +1); h = h2; }
  return cur;
}

/** Screen pixels -> page units at the current render width. */
export const pxToUnits = (px, svgEl) => {
  const w = svgEl?.getBoundingClientRect?.().width || 1000;
  return Math.max(2, (px / w) * 1000);
};
